import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=873ab1e8&scoped=true&"
import script from "./RolesList.vue?vue&type=script&lang=js&"
export * from "./RolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ab1e8",
  null
  
)

export default component.exports